import * as I18n from 'i18n-js';
import * as React from 'react';

import CmsPageCards, { CmsPageFields } from '@reverbdotcom/commons/dist/cms/components/cms_page_cards';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';

const CTA_URL = '/page/handpicked-collections';

function renderAction() {
  return (
    <CoreLink
      to={CTA_URL}
    >
      {I18n.t('discovery.homepageCuratedSetRow.cta')}
    </CoreLink>
  );
}

function getPageFields(): CmsPageFields[] {
  return [
    {
      slug: 'deals-and-steals',
    },
    {
      slug: 'price-drops',
    },
    {
      slug: 'reverb-exclusives-and-makers',
    },
  ];
}

export default function HomepageCuratedSetRow(props) {
  return (
    <CmsPageCards
      title={props.noTitle ? null : I18n.t('discovery.homepageCuratedSetRow.title')}
      action={renderAction()}
      pageFields={getPageFields()}
    />
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage_curated_set_row.tsx